/* eslint-disable global-require */
import { TabBar } from 'antd-mobile'
import React, { FC } from "react";
import { useHistory,useLocation } from "react-router-dom";

import useHox from "@/hoxModel/HoxModel";

const Footer: FC = () => {
  const location = useLocation()
  const history = useHistory()
  const { pathname } = location
  const {state} = useHox();
  const coviPath = `/index`
  const tabChange = (value: string) => {
    history.push(value)
  }
  return (
    <TabBar activeKey={pathname} onChange={value => tabChange(value)}>
      <TabBar.Item key="/home" title={
        <div>
          <img src={pathname==='/home'?require("@assets/home-active.png").default:require("@assets/home.png").default} alt="" style={{width: '23px',position:'relative','top':'-6px'}}/>
          <div style={{position:'absolute','bottom':'-10px'}}>首页</div>
        </div>
      } />
      <TabBar.Item style={{}} key={coviPath} badge="查询" title={
        <div>
          <img src={pathname==='/epidemic-situation'?require("@assets/covi-19-active.png").default:require("@assets/covi.png").default} alt="" style={{width: '23px',position:'relative','top':'-6px'}}/>
          <div style={{position:'absolute','bottom':'-10px'}}>疫情</div>
        </div>
      } />
    </TabBar>
  )
}

export default Footer